"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TurnstileMethods = void 0;
var TurnstileMethods;
(function (TurnstileMethods) {
    TurnstileMethods["HAS_TOKEN"] = "has-token";
    TurnstileMethods["NO_TOKEN"] = "no-token";
    TurnstileMethods["ERROR"] = "error";
    TurnstileMethods["BEFORE_INTERACTIVE"] = "before-interactive";
    TurnstileMethods["AFTER_INTERACTIVE"] = "after-interactive";
})(TurnstileMethods || (exports.TurnstileMethods = TurnstileMethods = {}));
